var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlacklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 4.621094 15.8125 L 12.519531 15.8125 L 12.519531 17.5 L 4.621094 17.5 Z M 14.839844 0.289062 L 16.503906 0 L 17.855469 7.78125 L 16.191406 8.070312 Z M 4.691406 14.4375 L 4.847656 12.757812 L 12.710938 13.484375 L 12.554688 15.160156 Z M 5.164062 10.859375 L 5.601562 9.230469 L 13.226562 11.28125 L 12.789062 12.910156 Z M 6.566406 6.792969 L 7.421875 5.339844 L 14.222656 9.351562 L 13.367188 10.804688 Z M 10.050781 2.597656 L 11.445312 1.644531 L 15.890625 8.171875 L 14.5 9.121094 Z M 10.050781 2.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.75 18.75 L 3.75 18.75 L 3.75 12.5 L 2.5 12.5 L 2.5 20 L 15 20 L 15 12.5 L 13.75 12.5 Z M 13.75 18.75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklogo);
export default __webpack_public_path__ + "static/media/blacklogo.1484672e20c7dfc1bfb49e4d1f274deb.svg";
export { ForwardRef as ReactComponent };